"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FUNDED_BY_NAME_MAX_LENGTH = void 0;
exports.FUNDED_BY_NAME_MAX_LENGTH = 190;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmFsaWRhdGlvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pbXBhY3QvdmFsaWRhdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLHlCQUF5QixHQUFHLEdBQUcsQ0FBQyJ9